import React from 'react';
import styled from '@emotion/styled';
import { StyledShowMoreButton } from '../../../../../shared/components';

const StyledNavigationPlaceholder = styled(StyledShowMoreButton)`
	&:hover {
		background: transparent;
		cursor: initial;
	}
`;

export const NavigationPlaceholder = () => (
	<StyledNavigationPlaceholder aria-label="Flights Navigation placeholder">
		<span>&nbsp;</span>
	</StyledNavigationPlaceholder>
);
